import { render, staticRenderFns } from "./notification-slider.vue?vue&type=template&id=f9621dee&scoped=true&"
import script from "./notification-slider.vue?vue&type=script&lang=js&"
export * from "./notification-slider.vue?vue&type=script&lang=js&"
import style0 from "./notification-slider.vue?vue&type=style&index=0&id=f9621dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9621dee",
  null
  
)

export default component.exports